export default "__VITE_ASSET__ef510400__"